import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedRoleProjectManager } from "../hooks/roles/ProtectedRoleProjectManager";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const NuevoProyecto = React.lazy(
  () => import("../screean/services/nuevo-proyecto")
);
export function nuevoProyecto() {
  return (
    <Route
      path="/nuevo-proyecto"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleProjectManager>
              <LazySuspense>
                <NuevoProyecto />
              </LazySuspense>
            </ProtectedRoleProjectManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
